<template>
    <div class="ftickets">
        <!-- <v-container class="mt-5">
            <v-row class="" justify="center">
                <v-card class="mx-0" max-width="1200">
                    <v-list two-line>
                        <v-subheader class="title">Open Tickets: {{callength}}</v-subheader>
                        <p class="red--text pl-4" v-if="feedback">{{feedback}}</p>
                        <v-list-item-group>
                            <v-list-item v-for="ticket in tickets" :key="ticket.id">
                                <v-list-item-icon>
                                    <v-icon dense right>mdi-ticket-outline</v-icon>    
                                </v-list-item-icon>
                                <v-list-item-content @click="checkstatus(ticket)">
                                    <v-list-item-title>{{ticket.id}} </v-list-item-title>
                                    <v-list-item-subtitle>{{ticket.subject}}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn icon>
                                        <v-icon color="grey lighten-1" @click="editticket(ticket)">mdi-circle-edit-outline</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card>
            </v-row>
        </v-container> -->
        <v-card :loading="loading" class="mt-5">
            <v-card-title>
                <h4 class="headline">
                    Freshdesk Open Tickets: {{callength}}
                </h4>
            </v-card-title>
            <v-card-title>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-row justify="end" class="mr-8">
                <p v-if="feedback" class="red--text caption">{{feedback}}</p>
            </v-row>
            <v-data-table class="headline"
            :headers="headers"
            :items="tickets"
            :search="search"
            >
                <template v-slot:item.action="{ item }">
                    <v-icon
                        class="mr-2"
                        @click="editticket(item)"
                    >
                        edit
                    </v-icon>
                    <v-icon
                        @click="checkstatus(item)"
                    >
                        mdi-progress-clock 
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
/* eslint-disable no-console */
import axios from 'axios'
import freshConfig from '@/freshconfig'
import companyIdObject from '@/freshDeskCompanyList'
import {db} from '@/fb'

export default {
    name:'ftickets',
    data(){
        return {
            tickets:[],
            feedback:null,
            editing:false,
            itemsPerPageOptions: [9, 18, 27],
            itemsPerPage: 8,
            search:'',
            headers: [
                {
                    text: 'Open Tickets',
                    align: 'left',
                    filterable: true,
                    value: 'id',
                },
                { text: 'Subject', value: 'subject' },
                { text: 'Company', value: 'company_id' },
                { text: 'Actions', value: 'action', sortable: false },
            ],
            loading:false,
            post_res:null,
        };
    },
    async created() {
        try{
            this.loading=true;

            const API_KEY = freshConfig.api_key;
            const FD_ENDPOINT = "tpoconcierge";
            var PATH = '/api/v2/search/tickets?query="status:2%20OR%20status:3%20OR%20status:8%20OR%20status:11%20OR%20status:13%20OR%20status:14%20OR%20status:16"&page=';
            var PAGE=1;
            const URL =  "https://" + FD_ENDPOINT + ".freshdesk.com"+ PATH + String(PAGE);
            const res = await axios({
                    method: 'get',
                    url: URL,
                    auth: {
                        username:API_KEY,
                        password:'X'
                    }
                });
            const total = res.data.total
            const iter = Math.ceil(total/30);
            
            for(parseInt(PAGE);PAGE<=iter;PAGE+=1){
                let URL2 =  "https://" + FD_ENDPOINT + ".freshdesk.com"+ PATH + String(PAGE);
                const Mres = await axios({
                    method: 'get',
                    url: URL2,
                    auth: {
                        username:API_KEY,
                        password:'X'
                    }
                });
                for(const result of Mres.data.results){
                    this.tickets.push({id:result.id, subject:result.subject, company_id:companyIdObject[result.company_id], description:result.description_text})
                }
            }
            // const post_url =  "https://" + FD_ENDPOINT + ".freshdesk.com"+ "/api/v2/tickets/26698/notes";
            // const post_res = await axios({
            //         method: 'post',
            //         url: post_url,
            //         auth: {
            //             username:API_KEY,
            //             password:'X'
            //         },
            //         data:{
            //             body: 'This is a test note',
            //             private: false,
            //         }
            //     });
            // this.post_res = post_res
            // this.$store.dispatch('AsyncFdTicketInfo',this.tickets);
            this.loading = false;
        }catch(err){
            /* eslint-disable no-console */
            console.log(err)
            /* eslint-enable no-console */
        }
    },
    computed:{
        callength(){
            return this.tickets.length
        }
    },
    methods:{
        // checkCompanyListAPI(){
        //     const API_KEY = freshConfig.api_key;
        //     const FD_ENDPOINT = "tpoconcierge";
        //     const url =  "https://" + FD_ENDPOINT + ".freshdesk.com"+ "/api/v2/companies?per_page=100&page=1";
        //     axios({
        //             method: 'get',
        //             url: url,
        //             auth: {
        //                 username:API_KEY,
        //                 password:'X'
        //             },
        //         }).then((res)=>{
        //             /* eslint-disable no-console */
        //             console.log(res.data)
        //             const objectMap = new Map()
        //             for(var i=0; i<res.data.length; i++){
        //                 objectMap.set(res.data[i]['id'],res.data[i]['name'])
        //             }
        //             // console.log(`"${objectMap.keys()}":"${objectMap.values()}"`)
        //             /* eslint-enable no-console */
        //         });
        // },
        checkstatus(ticket){
            let ref = db.collection('reports').where("id", "==", ticket.id)
            ref.get().then(snap=>{
                if(snap.empty){
                    this.editing = false
                    this.feedback = '未対応'
                }else{
                    snap.forEach(doc=>{
                        if(doc.data().editor == ""){
                            this.editing = false
                            this.feedback = '未対応'
                        }else{
                            this.editing = true
                            this.feedback = doc.data().editor+' が編集中です'
                        }
                    })
                }
            })
        },
        editticket(ticket){
            let ref = db.collection('reports').where("id", "==", ticket.id)
            ref.get().then(snap=>{
                if(snap.empty){
                    db.collection('reports').add({
                        id:ticket.id,
                        subject : ticket.subject,
                        description : ticket.description,
                        status: "editing",
                        pickUpTime: Date.now()
                    })
                    .then((docRef)=>{
                        this.$router.push({name:'TicketDetail', params:{id:docRef.id, ticket_id:ticket.id}})
                        .catch((err) => {
                            /* eslint-disable no-console */
                            console.log(err)
                            /* eslint-enable no-console */
                        });
                    })
                    .catch(err=>{
                        /* eslint-disable no-console */
                        console.log(err)
                        /* eslint-enable no-console */
                    })
                }else{
                    snap.forEach(doc=>{
                        if(doc.exists){
                            this.$router.push({name:'TicketDetail', params:{id:doc.id,ticket_id:ticket.id}})
                    }})
                }
            })
        }
    }
}
</script>